import React, { useEffect } from "react";
import Header from "../Templete/Header";
import Footer from "../Templete/Footer";
import WhyChooseUs from "../Home/WhyChooseUs";

const Services = () => {
  useEffect(() => {
    document.title = "Our Services | FORMAX MONEY";
  }, []);

  const services = [
    {
      id: 1,
      name: "AEPS (Aadhaar Enabled Payment System)",
      icon: "fas fa-fingerprint",
      description:
        "Enable cash withdrawal, balance inquiry, and mini statements using Aadhaar authentication. Serve customers with secure and instant banking services at your BC outlet.",
      color: "#D4AF37",
    },
    {
      id: 2,
      name: "Domestic Money Transfer (DMT)",
      icon: "fas fa-exchange-alt",
      description:
        "Instant money transfer to any bank account across India. High success rate with real-time settlements for BC Agents and their customers.",
      color: "#D4AF37",
    },
    {
      id: 3,
      name: "Cash Management Services (CMS)",
      icon: "fas fa-truck",
      description:
        "Efficient cash collection, delivery, and management solutions for businesses and retail agents. Streamlined operations with complete transparency.",
      color: "#D4AF37",
    },
    {
      id: 4,
      name: "UPI Cash Point (Coming Soon)",
      icon: "fas fa-mobile-alt",
      description:
        "Enable cash withdrawal through UPI QR at your retail point. Earn attractive commissions on every transaction with zero infrastructure cost.",
      color: "#D4AF37",
    },
    {
      id: 5,
      name: "Micro ATM",
      icon: "fas fa-credit-card",
      description:
        "Provide banking services like cash withdrawal, deposit, and balance inquiry using Micro ATM devices. Bring bank to every doorstep.",
      color: "#D4AF37",
    },
  ];

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Our Financial Services</h1>
          <p>
            Comprehensive banking and financial inclusion solutions for BC
            Agents to serve their communities better.
          </p>
        </div>
      </section>

      <div className="container">
        <div className="services-page">
          <div className="services-intro">
            <p>
              FORMAX MONEY, a bank-licensed Corporate Business Correspondent,
              offers a comprehensive suite of financial inclusion services. Our
              platform enables BC Agents to provide essential banking services
              including{" "}
              <strong>AEPS, DMT, CMS, UPI Cash Point and Micro ATM</strong> to
              unbanked and underbanked communities across India.
            </p>
          </div>

          <div className="services-grid-page">
            {services.map((service) => (
              <div className="service-card-page" key={service.id}>
                <div
                  className="service-icon-page"
                  style={{
                    background: "rgba(212, 175, 55, 0.12)",
                    color: service.color,
                  }}
                >
                  <i className={service.icon}></i>
                </div>
                <h3>{service.name}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>

          {/* BC Agent Benefits Section */}
          <div className="services-benefits">
            <h2>Benefits for BC Agents</h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <i className="fas fa-chart-line"></i>
                <h4>High Commissions</h4>
                <p>Industry-best payout structure on all services</p>
              </div>
              <div className="benefit-item">
                <i className="fas fa-clock"></i>
                <h4>Real-time Settlements</h4>
                <p>Instant commission credits to your bank account</p>
              </div>
              <div className="benefit-item">
                <i className="fas fa-headset"></i>
                <h4>24/7 Dedicated Support</h4>
                <p>Technical and operational assistance anytime</p>
              </div>
              <div className="benefit-item">
                <i className="fas fa-shield-alt"></i>
                <h4>Secure Platform</h4>
                <p>Bank-grade security for all transactions</p>
              </div>
              <div className="benefit-item">
                <i className="fas fa-mobile-alt"></i>
                <h4>Easy-to-Use Interface</h4>
                <p>Simple dashboard for all banking services</p>
              </div>
              <div className="benefit-item">
                <i className="fas fa-chalkboard-teacher"></i>
                <h4>Free Training</h4>
                <p>Complete onboarding and operational training</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style>{`
        .page-hero {
          background: linear-gradient(135deg, #0A2540 0%, #1A3A5F 100%);
          padding: 60px 0 70px;
          text-align: center;
        }
        .page-hero h1 {
          font-size: 2.8rem;
          margin-bottom: 16px;
          color: white;
          font-weight: 700;
        }
        .page-hero p {
          color: rgba(255,255,255,0.85);
          max-width: 600px;
          margin: 0 auto;
          font-size: 1.1rem;
        }
        
        .services-page {
          margin: 60px 0;
        }
        
        .services-intro {
          text-align: center;
          max-width: 850px;
          margin: 0 auto 50px auto;
          font-size: 1.1rem;
          color: #475569;
          line-height: 1.6;
        }
        
        .services-intro strong {
          color: #D4AF37;
        }
        
        .services-grid-page {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 32px;
          margin-bottom: 60px;
        }
        
        .service-card-page {
          background: white;
          border-radius: 28px;
          padding: 32px 24px;
          text-align: center;
          transition: all 0.3s ease;
          box-shadow: 0 10px 25px -5px rgba(0,0,0,0.05);
          border: 1px solid #eef2ff;
        }
        
        .service-card-page:hover {
          transform: translateY(-8px);
          box-shadow: 0 25px 35px -12px rgba(0,0,0,0.12);
          border-color: rgba(212, 175, 55, 0.3);
        }
        
        .service-icon-page {
          font-size: 2.5rem;
          width: 80px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 24px;
          margin: 0 auto 24px;
        }
        
        .service-card-page h3 {
          font-size: 1.35rem;
          margin-bottom: 12px;
          font-weight: 700;
          color: #0A2540;
        }
        
        .service-card-page p {
          color: #64748b;
          margin-bottom: 0;
          line-height: 1.6;
        }
        
        .services-benefits {
          background: linear-gradient(135deg, #F8FAFE 0%, #F1F5F9 100%);
          border-radius: 32px;
          padding: 48px 32px;
          text-align: center;
          margin-bottom: 60px;
        }
        
        .services-benefits h2 {
          font-size: 2rem;
          margin-bottom: 40px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .benefits-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 32px;
        }
        
        .benefit-item {
          text-align: center;
          padding: 20px;
          background: white;
          border-radius: 20px;
          transition: all 0.3s ease;
        }
        
        .benefit-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px -10px rgba(0,0,0,0.1);
        }
        
        .benefit-item i {
          font-size: 2.5rem;
          color: #D4AF37;
          margin-bottom: 16px;
        }
        
        .benefit-item h4 {
          font-size: 1.1rem;
          margin-bottom: 8px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .benefit-item p {
          color: #64748b;
          font-size: 0.85rem;
          line-height: 1.5;
        }
        
        @media (max-width: 768px) {
          .page-hero {
            padding: 40px 0 50px;
          }
          .page-hero h1 { 
            font-size: 2rem; 
          }
          .page-hero p {
            font-size: 1rem;
            padding: 0 20px;
          }
          .services-intro {
            font-size: 1rem;
            padding: 0 16px;
          }
          .services-benefits h2 { 
            font-size: 1.6rem; 
          }
          .service-card-page h3 { 
            font-size: 1.2rem; 
          }
          .services-grid-page {
            grid-template-columns: 1fr;
            gap: 24px;
          }
        }
        
        @media (max-width: 576px) {
          .services-benefits {
            padding: 32px 20px;
          }
          .benefit-item {
            padding: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default Services;
